import React, { useState } from "react";
import  "./contextMenu.css"
import * as myTreeIcons from "../../images/icons/treeicons";
import { kamerItem } from "../../Shared/sharedInterfaces";
interface MyProps {
  visible: boolean;
  position: { x: number, y: number };
  item: kamerItem;
  onClose: (contextVisible: boolean) => void;
}

const ModulesContext: React.FC<MyProps> = ({ visible, position, item, onClose }) => {

  const handleClose = () => {
    onClose(false);
  };

  const renderContext = () => {
    const contextMenu = () => (
      <div
        style={{
          top: position.y,
          left: position.x,
          position: "absolute",
        }}
        className="contextOutputs"
        onClick={handleClose}
      >
        <div className="contextOutputsElement">Voeg module toe</div>
        {item.key}
      </div>
    );
    return contextMenu();
  };

  return <>{visible ? renderContext() : <></>}</>;
};

export default ModulesContext;
